import { OIDC_RETURN_URL_KEY } from 'src/hooks/useLogin';
import { userManager } from 'src/userManager';

export const useAuthProvider = () => {
  const onSigninCallback = () => {
    const url = new URL(window.location.href);
    const search = url.searchParams;
    const isEmbeddedContext = window.self !== window.top;

    search.delete('state');
    search.delete('session_state');
    search.delete('iss');
    search.delete('code');

    if (isEmbeddedContext) {
      window.history.replaceState(
        {},
        document.title,
        `${window.location.pathname}${search.toString() ? `?${search.toString()}` : ''}`,
      );
      return;
    }

    const returnPath = sessionStorage.getItem(OIDC_RETURN_URL_KEY);
    if (returnPath) {
      sessionStorage.removeItem(OIDC_RETURN_URL_KEY);
      window.location.replace(`${window.location.origin}${returnPath}`);
      return;
    }

    window.history.replaceState(
      {},
      document.title,
      `${window.location.pathname}${search.toString() ? `?${search.toString()}` : ''}`,
    );
  };

  return { onSigninCallback, userManager };
};
